import { FC, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { Drawer, Header, NavBar, RenderArrows } from "components";
import styles from "./styles.module.scss";
import { SettingsContext } from "context";
import {
  CONTOSO_COPILOT_PROD,
  CONTOSO_COPILOT_PROD_HARDCODED,
  CONTOSO_COPILOT_WITH_DASH,
  CONTOSO_COPILOT_WITH_WEBSOCKET,
  arrowConfig,
  routeDefinitions,
} from "common";
import { useAppDispatch } from "hooks";
import { useSelector } from "react-redux";
import { login } from "store";

export const Layout: FC = () => {
  const [expanded, setExpanded] = useState(false);
  const { currentDemo } = useContext(SettingsContext);
  // const { arrowConfig, routeDefinitions } = useArrows();
  const dispatch = useAppDispatch();

  let showNav = true;
  // We're hiding navbar header and arrows based on if it's an iframe
  if (window.location !== window.parent.location) {
    showNav = false;
  } else {
    showNav = true;
  }

  useEffect(() => {
    dispatch(login());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showNav]);

  return (
    <div>
      {showNav && (
        <>
          <Header expanded={expanded} setExpanded={setExpanded} />
          <NavBar />
          <Drawer expanded={expanded} setExpanded={setExpanded} />
          {currentDemo?.guid && (
            <RenderArrows
              arrowConfig={arrowConfig}
              routeDefinitions={
                currentDemo?.guid === CONTOSO_COPILOT_PROD
                  ? {
                      mainFlow: [
                        "landing_page",
                        "shopping_copilot",
                        "chat_bot",
                        "shopping_copilot_new",
                        "social_media_campaign",
                        "call_center_before_summary",
                        "call_center_before_script",
                        "customer_conversation",
                        "call_center",
                        "call_center_after_script",
                        "call_center_after_summary",
                        "shopping_copilot_cosmos",
                        "chat_bot_2",
                        "shopping_copilot_uat",
                        "shopping_copilot_mtc",
                      ],
                    }
                  : currentDemo?.guid === CONTOSO_COPILOT_WITH_WEBSOCKET
                  ? {
                      mainFlow: [
                        "landing_page",
                        "shopping_copilot",
                        "chat_bot",
                        "shopping_copilot_new",
                        "social_media_campaign",
                        "call_center_before_summary",
                        "call_center_before_script",
                        "customer_conversation",
                        "call_center",
                        "call_center_after_script",
                        "call_center_after_summary",
                        "shopping_assistant_cosmos",
                      ],
                    }
                  : currentDemo?.guid === CONTOSO_COPILOT_WITH_DASH
                  ? {
                      mainFlow: [
                        "landing_page",
                        "world_map",
                        "city_view",
                        "ceo_dashboard_before",
                        "org_chart",
                        "shopping_copilot",
                        "chat_bot",
                        "social_media_campaign",
                        "call_center_before_summary",
                        "call_center_before_script",
                        "customer_conversation",
                        "call_center",
                        "call_center_after_script",
                        "call_center_after_summary",
                        "ceo_dashboard_after",
                        "finale_video",
                      ],
                    }
                  : currentDemo?.guid === CONTOSO_COPILOT_PROD_HARDCODED
                  ? {
                      mainFlow: [
                        "landing_page",
                        "shopping_copilot_new",
                        "chat_bot",
                        "social_media_campaign",
                        "call_center_before_summary",
                        "call_center_before_script",
                        "customer_conversation",
                        "call_center",
                        "call_center_after_script",
                        "call_center_after_summary",
                      ],
                    }
                  : routeDefinitions
              }
            />
          )}
        </>
      )}
      <div className={showNav ? styles.container : styles.iframeContainer}>
        <Outlet />
      </div>
    </div>
  );
};
